import React, { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ServicesOverview from "../components/ServicesOverview";
import AboutSection from "../components/AboutSection";
import SectorServices from "../components/SectorServices";
import ProjectsShowcase from "../components/ProjectsShowcase";
import TeamSection from "../components/TeamSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <Hero />
        <ServicesOverview />
        <AboutSection />
        <SectorServices />
        <ProjectsShowcase />
        <TeamSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;